// extracted by mini-css-extract-plugin
export default {"cardContainer":"concern_cardContainer__kiGzw","showCard":"concern_showCard__p5E7B","editStyle":"concern_editStyle__jO4ay","font20":"concern_font20__9vSqN"};